export default class Assets {
    public static conversationSpeechBubbles = require("./conversation-speech-bubbles.svg");

    public static contract = require("./contract.svg");

    public static icon = require("./icon.svg");

    public static income = require("./income.svg");

    public static done = require("./done.svg");

    public static doneActive = require("./done_active.svg");

    public static bell = require("./bell.png");

    public static openBook = require("./open-book.svg");

    public static language = require("./language.svg");

    public static tutorial2 = require("./tutorial2.png");

    public static tutorial3_01 = require("./tutorial-step-3-01.svg");

    public static login = require("./login.svg");

    public static password_reset = require("./password_reset.svg");

    public static customer_create = require("./customer_create.svg");

    public static super_engineer_create = require("./super_engineer_create.svg");

    public static pro_create = require("./pro_create.svg");

    public static apply_client = require("./apply_client.svg");

    public static apply_client_demo = require("./apply_client_demo.svg");

    public static sp_tutorial3 = require("./sp_tutorial3.png");

    public static thanks_toptalent_logo = require("./thanks-toptalent-logo.svg");

    public static expert_network_logo = require("./expert_network_logo.svg");

    public static expertnetwork_logo = require("./expertnetwork-logo.png");

    public static expertnetwork_logo2 = require("./expertnetwork-logo2.png");

    public static lafool_expertnetwork = require("./lafool_expertnetwork.png");

    public static polygon = require("./Polygon 1.png");

    public static contract_news_banner = require("./contract-news-banner.png");

    public static contract_news_banner_sp = require("./contract-news-banner-sp.png");

    public static security_image = require("./security_image.png");

    public static dx_image = require("./dx_image.png");

    public static cfo_image = require("./cfo_image.png");

    public static ipo_image = require("./ipo_image.png");

    public static new_business_image = require("./new_business_image.png");

    public static outside_director_image = require("./outside_director_image.png");

    public static corporate_business_planning = require("./corporate_business_planning.png");

    public static business_development = require("./business_development.png");

    public static marketing = require("./marketing.png");

    public static public_relations = require("./public_relations.png");

    public static web_marketing = require("./web_marketing.png");

    public static sales = require("./sales.png");

    public static human_resource = require("./human_resource.png");

    public static ministry_of_justice = require("./ministry_of_justice.png");

    public static information_system = require("./information_system.png");

    public static engineer = require("./engineer.png");

    public static ipo_occupation = require("./ipo_occupation.png");

    public static finance = require("./finance.png");

    public static client_top_page_header = require("./client_top_page_header.png");

    public static contract_card = require("./contract_card.png");

    public static activity_card = require("./activity_card.png");

    public static invoice_card = require("./invoice_card.png");

    public static admin_image = require("./admin_image.png");

    public static dummy_paragraph = require("./dummy-paragraph.png");

    public static pm_campaign = require("./pm_campaign.png");
    public static marketing_campaign = require("./marketing_campaign.png");
    public static sales_campaign = require("./sales_campaign_bannar.png");
    public static ipo_campaign = require("./ipo_campaign_bannar.png");
    public static event = require("./event.png");

    public static building = require("./building.svg");
    public static past_project = require("./past_project.svg");

    public static new_search = require("./new_search.png");

    public static heartIcon = require("./heart-icon.svg");
    public static heartIconOn = require("./heart-icon.on.svg");
    public static scoutIcon = require("./scout-icon.svg");

    public static arrowDown = require("./arrow_down.svg");
    public static arrowRight = require("./arrow_right.svg");

    public static headerUser = require("./header-user.svg");
    public static headerPlan = require("./header-plan.svg");
    public static up_right_from_square_solid = require("./up-right-from-square-solid.svg");

    public static bengoshi = require("./bengoshi.com.png");
    public static zeirishi = require("./zeirishi.com.png");

    public static partnerStoreBg = require("./partner-store-bg.png");
    public static partnerStoreIc1 = require("./partner-store-ic1.png");
    public static partnerStoreIc2 = require("./partner-store-ic2.png");
    public static partnerStoreIc3 = require("./partner-store-ic3.png");
    public static partnerStoreIc4 = require("./partner-store-ic4.png");
    public static partnerStoreIc5 = require("./partner-store-ic5.png");
    public static partnerStoreIc6 = require("./partner-store-ic6.png");
    public static partnerStoreFlow1 = require("./partner-store-flow1.png");
    public static partnerStoreFlow2 = require("./partner-store-flow2.png");
    public static partnerStoreFlow3 = require("./partner-store-flow3.png");
    public static partnerStoreListIc1 = require("./partner-store-list-ic1.png");
    public static partnerStoreListIc2 = require("./partner-store-list-ic2.png");
    public static partnerStoreListIc3 = require("./partner-store-list-ic3.png");
    public static partnerStoreListIc4 = require("./partner-store-list-ic4.png");
    public static partnerStoreListIc5 = require("./partner-store-list-ic5.png");
    public static partnerStoreListIc6 = require("./partner-store-list-ic6.png");
    public static partnerStoreListArrow = require("./partner-store-list-arrow.png");
    public static partnerSample = require("./partner-sample.png");

    public static publicCustomerIcon = require("./public_customer_icon.png");

    public static star = require("./star.png");
    public static starGray = require("./star-gray.png");

    public static help = require("./help.svg");

    public static cover1 = require("./cover1.png");
    public static cover2 = require("./cover2.png");
    public static cover3 = require("./cover3.png");
    public static cover4 = require("./cover4.png");
    public static cover5 = require("./cover5.png");
    public static cover6 = require("./cover6.png");
    public static cover7 = require("./cover7.png");
    public static cover8 = require("./cover8.png");
    public static cover9 = require("./cover9.png");
    public static cover10 = require("./cover10.png");
    public static cover11 = require("./cover11.png");
    public static cover12 = require("./cover12.png");
    public static cover13 = require("./cover13.png");
    public static cover14 = require("./cover14.png");
    public static cover15 = require("./cover15.png");
    public static cover16 = require("./cover16.png");

    public static sharingPage = require("./sharing-page.png");

    public static sharingBanner = require("./sharing-banner.png");
    public static partnerStoreBanner = require("./partner-store-banner.png");

    public static consultationHeader = require("./consultation_header.png");
    public static consultation01 = require("./consultation_01.png");
    public static consultation02 = require("./consultation_02.png");
    public static consultation03 = require("./consultation_03.png");
    public static consultation04 = require("./consultation_04.png");
    public static consultation05 = require("./consultation_05.png");
    public static consultationMessageBG = require("./consultation_message_bg.png");
}



// WEBPACK FOOTER //
// ./src/presentation/assets/img/assets.ts